import { Box, Grid, Tab, Tabs, Typography } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import './InvalidCheck.scss';
import { useDispatch, useSelector } from 'react-redux';
import InvalidTonnageTable from './InvalidTonnageTable';
import InvalidCargoTable from './InvalidCargoTable';
import InvalidMarketInfoTable from './InvalidMarketInfoTable';

let triggerHotkeyAlready = false;

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

const InvalidCheck: React.FunctionComponent = () => {
    const dispatch = useDispatch();

    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    useEffect(() => {
        document.title = "Invalid Check";
    }, []);

    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label="Tonnage" />
                    <Tab label="Cargo" />
                    <Tab label="MarketInfo" />
                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
                <InvalidTonnageTable></InvalidTonnageTable>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <InvalidCargoTable></InvalidCargoTable>
            </TabPanel>
            <TabPanel value={value} index={2}>
                <InvalidMarketInfoTable></InvalidMarketInfoTable>
            </TabPanel>
        </>
    )
};

export default InvalidCheck;